import React, { memo, ReactNode } from 'react'
import { CaretDownMinor, CaretUpMinor } from '@shopify/polaris-icons'
import { Button, contentColors, ButtonProps } from './Button'
import tw from 'twin.macro'

interface Props extends ButtonProps {
  icon?: ReactNode
  text: string
}

const ActionButtonComponent = ({
  icon,
  text,
  variant = 'contained',
  size = 'small',
  color = 'primary',
  selected,
  className,
  ...props
}: Props) => (
  <Button
    {...props}
    variant={variant}
    size={size}
    color={color}
    leftIcon={icon}
    selected={selected}
    rightIcon={
      selected ? (
        <CaretUpMinor width={20} fill={contentColors[color]} />
      ) : (
        <CaretDownMinor width={20} fill={contentColors[color]} />
      )
    }
    className={[tw`px-2`, className]}
  >
    {text}
  </Button>
)

export const ActionButton = memo(ActionButtonComponent)
